/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_4_DescInputs */

const en_mk_how_4_desc = /** @type {(inputs: Mk_How_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the result in In Review, approve outbound actions in Approval — you make the call.`)
};

const id_mk_how_4_desc = /** @type {(inputs: Mk_How_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review hasil di In Review, setujui aksi keluar di Approval — kamu yang memutuskan.`)
};

/**
* | output |
* | --- |
* | "Review the result in In Review, approve outbound actions in Approval — you make the call." |
*
* @param {Mk_How_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_4_desc = /** @type {((inputs?: Mk_How_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_4_desc(inputs)
	return en_mk_how_4_desc(inputs)
});